import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useIntl } from 'react-intl';
import { commonMessages } from 'utils/commonMessages';
import { ServiceCallAttachmentPreview } from './ServiceCallAttachmentPreview';
import { Attachment } from 'modules/service-call/types';

type ServiceCallAttachmentDeleteDialogProps = {
  attachment: Attachment
  serviceCallId: string
  noteId: number,
  isOpen: boolean,
  onClose: () => void,
  onDelete: () => void
}

export const ServiceCallAttachmentDeleteDialog: React.FC<ServiceCallAttachmentDeleteDialogProps> = (props: ServiceCallAttachmentDeleteDialogProps) => {
  const { formatMessage } = useIntl();

  return(
    <Dialog
      open={props.isOpen}
      onClose={props.onClose}
    >
      <DialogTitle>{formatMessage({ id: 'ServiceCallAttachmentDeleteDialog.Title', defaultMessage: 'Delete attachment' })}</DialogTitle>
      <DialogContent>
        <DialogContentText color='text.primary'>{formatMessage({ id: 'ServiceCallAttachmentDeleteDialog.Description', defaultMessage: 'Are you sure you want to delete this attachment.' })}</DialogContentText>
      </DialogContent>
      <DialogContent>
        <ServiceCallAttachmentPreview attachment={props.attachment} serviceCallId={props.serviceCallId} noteId={props.noteId} />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose}>{formatMessage(commonMessages.cancel)}</Button>
        <Button variant='contained' color='error' onClick={props.onDelete} autoFocus>{formatMessage(commonMessages.delete)}</Button>
      </DialogActions>
    </Dialog>
  );
};